function _log(message)
{
  console.log(message);
}

function scrollToElement(elementId) {
    var element = document.getElementById(elementId);
    element.scrollIntoView({block: "start", behavior: "smooth"});
}


function httpHuildQuery ( activeFilters )
{
    const queryArgs  = activeFilters;

    let query_string = "";
    for (let key in queryArgs) {
        let value = null;
        if (queryArgs[key] === null) {
            continue;
        }
        if (typeof queryArgs[key] === "string" || typeof queryArgs[key] === "number" ) {
            if (value = queryArgs[key]) {
                query_string += key+"="+value+"&";
            }
        } else if (typeof queryArgs[key] === "object") {
            for(let c=0; c<queryArgs[key].length; c++) {
                let value = queryArgs[key][c];
                query_string += key+"[]="+value+"&";
            }
        }
    }

    return (query_string) ? "?"+query_string : null;
};

export { _log, httpHuildQuery, scrollToElement };